import React from 'react'

export const Well = ({ children }) => {
    return <div className="bg-[#f1f3f4] border border-[#bfbfc2] p-4 rounded-md">{children}</div>
}
